import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BillingPaymentMethodFeatureModule } from '@amfam/billing/payment-method/feature';
import { BillingSharedUiModule } from '@amfam/billing/shared/ui';
import { OverviewUiModule } from '@amfam/overview/ui';
import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { BillAccountCardComponent } from './components/bill-account-card/bill-account-card.component';
import { OverviewBillingWrapperComponent } from './containers/overview-billing-wrapper/overview-billing-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    OverviewUiModule,
    SharedServicesModule,
    DsRouterLinkModule,
    UiKitModule,
    BrandDirectivesModule,
    PipesModule,
    BillingSharedUiModule,
    BillingPaymentMethodFeatureModule
  ],
  declarations: [BillAccountCardComponent, OverviewBillingWrapperComponent],
  exports: [BillAccountCardComponent, OverviewBillingWrapperComponent]
})
export class OverviewBillingFeatureModule {}
